import {
  AppBar,
  Toolbar,
  Grid,
  Typography,
  IconButton,
  Box,
  Chip
} from '@material-ui/core'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import AccountCircleOutlineIcon from 'mdi-react/AccountCircleOutlineIcon'
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon'
import CalendarMonthOutlineIcon from 'mdi-react/CalendarMonthOutlineIcon'
import HomeCityOutlineIcon from 'mdi-react/HomeCityOutlineIcon'
import MessageIcon from 'mdi-react/MessageIcon'
import AccountSearchOutline from 'mdi-react/AccountSearchOutlineIcon'
import ChartTimelineVariantIcon from 'mdi-react/ChartTimelineVariantIcon'
import { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { matchPath } from 'react-router'
import { NavLanguageForm, DesktopMenu, NavDrawer } from '.'
import { ReactComponent as TwoStripesMenuBarIcon } from '../../../images/navigation/twoStripesMenuIcon.svg'
//import { isSmallScreen, getIsTinyScreen } from '../../../libs/screenSize'
import { MuiClasses } from '../../../types'
import { isNumStep } from '../../../utils/apartments'
import { TalkUser, initialize } from '../../../utils/talkChat'
import { BaseNavMenuProps, NavMenuActionProps } from '../types'
//import NavBarPhoneNumber from './NavBarPhoneNumber'
import VO_Leea_White from '../../../images/VO_Leea_White.svg'
import { NotifyPaymentStatus } from '../../../components/Messages/NotifyPaymentStatus';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import TawkToWidget from '../../../components/TawkJs/tawkToWidget'

const navItems = [
  {
    id: '/overview',
    label: 'navigation.apartments',
    icon: HomeCityOutlineIcon
  },
  {
    id: '/statistic',
    label: 'navigation.statistics',
    icon: ChartTimelineVariantIcon
  },
  {
    id: '/applications',
    label: 'navigation.applicants',
    icon: AccountGroupOutlineIcon
  },
  {
    id: '/messages',
    label: 'navigation.messages',
    icon: MessageIcon
  },
  {
    id: '/tenants',
    label: 'navigation.tenants',
    icon: AccountSearchOutline
  },
  {
    id: '/showings/overview',
    label: 'navigation.calendar',
    icon: CalendarMonthOutlineIcon
  },
  {
    id: '/apartments',
    label: 'navigation.menu',
    icon: TwoStripesMenuBarIcon
  },
  {
    id: '/profile',
    label: 'navigation.profile',
    icon: AccountCircleOutlineIcon
  }
]

const adminUserNavItems = [
  {
    id: '/overview',
    label: 'navigation.apartments',
    icon: HomeCityOutlineIcon
  },
  {
    id: '/statistic',
    label: 'navigation.statistics',
    icon: ChartTimelineVariantIcon
  },
  {
    id: '/applications',
    label: 'navigation.applicants',
    icon: AccountGroupOutlineIcon
  },
  // {
  //   id: '/messages',
  //   label: 'navigation.messages',
  //   icon: MessageIcon
  // },
  {
    id: '/showings/overview',
    label: 'navigation.calendar',
    icon: CalendarMonthOutlineIcon
  },
  {
    id: '/adminApartments/marketing',
    label: 'navigation.menu',
    icon: TwoStripesMenuBarIcon
  },
  {
    id: '/profile',
    label: 'navigation.profile',
    icon: AccountCircleOutlineIcon
  }
]

interface NavBarProps {
  handleToggleDrawer: () => void
  drawerOpen: boolean
  isAuthenticated: boolean
  isAdminUser: boolean
  classes: MuiClasses
  pathname: string
  width: Breakpoint
  doNavigation: (path: string) => void
  showLanguageSwitcher: boolean
  userAttributes: any
  hasStatistics: boolean
}

const NavBar = ({
  handleToggleDrawer,
  drawerOpen,
  isAuthenticated,
  isAdminUser,
  classes,
  doNavigation,
  showLanguageSwitcher,
  pathname,
  width,
  userAttributes,
  hasStatistics
}: NavBarProps) => {
  const smallScreen = window.innerWidth < 1066;
  const quiteSmallScreen = window.innerWidth < 500;
  const verySmallScreen = window.innerWidth < 330;
  //const isTinyScreen = getIsTinyScreen(width)
  const currentPathEnd = pathname.includes('/showings/overview')
    ? '/showings/overview'
    : pathname.substring(pathname.lastIndexOf('/'))
  const baseNavMenuProps: BaseNavMenuProps = { classes }
  const isNewApplication = (pathname: string) =>
    pathname.split('/')[1] == 'new-application'
  const [unreadMessages, setUnreadMessages] = useState(0)
  const { t } = useTranslation()
  const location = useLocation()
  const isApartmentDetailRoute = Boolean(
    matchPath(pathname, {
      path: '/users/:userId/apartments/:apartmentId',
      exact: false,
      strict: false
    })
  )
  const isContractRoute = Boolean(
    matchPath(pathname, {
      path: '/users/:userId/apartments/:apartmentId/contract/:applicationCode',
      exact: false,
      strict: false
    })
  )
  const highlightedPath = isContractRoute ? '/applications' : currentPathEnd
  const baseNavItems = isAdminUser ? adminUserNavItems : navItems
  const filteredNavItems = hasStatistics
    ? baseNavItems
    : baseNavItems.filter((item) => item.id !== '/statistic')

  const navMenuActionProps: NavMenuActionProps = {
    doNavigation,
    navItems: filteredNavItems,
    currentPathEnd: highlightedPath,
    unreadMessages: unreadMessages
  }
  useEffect(() => {
    NotifyPaymentStatus({
      locationSearch: location.search,
      t
    });
  }, [location.search]);

  const unreadMessageEvent = () => {
    if (window.talkSession) {
      const initial = Number(window.talkSession.unread) || 0
      setUnreadMessages(initial)
      window.talkSession.unreads.on('change', function () {
        const current = Number(window.talkSession.unread) || 0
        setUnreadMessages(current)
      })
    }
  }

  const createChatSession = async () => {
    if (isAuthenticated && !isAdminUser && userAttributes?.email) {
      const talkUser: TalkUser = {
        id: userAttributes.email,
        name: userAttributes.name,
        email: userAttributes.email,
        phone: userAttributes?.phone_number,
        role: isAdminUser ? 'admin' : 'owner'
      }
      await initialize(talkUser)
      unreadMessageEvent()
    }
  }

  useEffect(() => {
    ; (async () => {
      setImmediate(async () => {
        await createChatSession()
      })
    })()

    /* eslint-disable-next-line @typescript-eslint/no-empty-function */
    return () => { }
  }, [isAuthenticated, isAdminUser, userAttributes])

  const chatWithSupport = async () => {
    console.log('Chat with support clicked', window, JSON.stringify(window.TALK))
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
    } else {
      console.log('Tawk.to not loaded yet');
    }
  }

  const chatWithSupportButton = (
    <a href="javascript:void(0);"
      onClick={chatWithSupport}
      style={{
        marginTop: verySmallScreen ? '0px' : '5px',
        textDecoration: 'none',
        color: 'inherit',
        textTransform: 'uppercase',
        marginLeft: verySmallScreen ? '10px' : '20px'
      }}
    >
      <Chip
        variant="outlined"
        color="primary"
        size="small"
        label={<span>{t('general.support')}</span>}
        style={{
          color: '#920049',
          border: '1px solid #d6b4c5',
          backgroundColor: '#d6b4c5',
          fontSize: smallScreen ? '10px' : '12px',
          borderRadius: '6px',
          padding: '0px',
          cursor: 'pointer'
        }}
      />
    </a>
  )

  return (
    <Fragment>
      <TawkToWidget />
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.navToolbar}>
          <Grid
            className={classes.menuItems}
            container
            direction='row'
            alignItems='center'
            justify='space-between'
            style={{
              paddingRight: isNewApplication(pathname)
                ? smallScreen
                  ? '0px'
                  : '50px'
                : '0px'
            }}
          >
            <Grid item>
              <Typography className={classes.logoContainer}>
                {pathname.includes('/reserve') ||
                  pathname.includes('/create') ||
                  isNumStep(pathname, '10') ? (
                  <Typography>
                    <img
                      className={classes.logo}
                      src={VO_Leea_White}
                      alt='Leea.fi Logo'
                    />
                  </Typography>
                ) : pathname.includes('/tenants') ? (
                  <a href="https://leea.fi" target="_blank" rel="noopener noreferrer">
                    <img
                      className={classes.logo}
                      src={VO_Leea_White}
                      alt='Leea.fi Logo'
                    />
                  </a>
                ) : (
                  <Link to='/'>
                    <img
                      className={classes.logo}
                      src={VO_Leea_White}
                      alt='Leea.fi Logo'
                    />
                  </Link>
                )}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: quiteSmallScreen ? '-7px' : '-3px' }}>
                  {chatWithSupportButton}
                </div>
              </Typography>
            </Grid>
            {isAuthenticated ? (
              smallScreen ? (
                <>
                  <Grid item xs={2} sm={1} className={classes.mobileMenu}>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={() => {
                        if (isApartmentDetailRoute) {
                          doNavigation('/apartments')
                          return
                        }
                        if (!isNumStep(pathname, '10')) {
                          handleToggleDrawer()
                        }
                      }}
                      className={classes.menuButton}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <TwoStripesMenuBarIcon
                          color="#fff"
                          style={{
                            opacity: isNumStep(pathname, '10') ? '0.6' : '1',
                            width: '100%',
                          }}
                        />
                        <span style={{ fontSize: '12px', color: '#fff', marginTop: '7px' }}>{t('navigation.iconText')}</span>
                      </Box>
                    </IconButton>
                  </Grid>
                </>
              ) : (
                <>
                  <DesktopMenu {...baseNavMenuProps} {...navMenuActionProps} />
                </>
              )
            ) : (
              showLanguageSwitcher && (
                <NavLanguageForm classes={classes} smallScreen={smallScreen} />
              )
            )}
          </Grid>
        </Toolbar>
      </AppBar>

      {smallScreen && isAuthenticated && (
        <NavDrawer
          {...baseNavMenuProps}
          {...navMenuActionProps}
          handleToggleDrawer={handleToggleDrawer}
          isOpen={drawerOpen}
        />
      )}
    </Fragment>
  )
}

export default NavBar
